export enum COMMUNITIES_PERMISSIONS {
    COMMUNITY_CREATE = 'COMMUNITY_CREATE',
    COMMUNITY_EDIT = 'COMMUNITY_EDIT',
    COMMUNITY_DELETE = 'COMMUNITY_DELETE',
}
